<div
    class="relative w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent">
    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        Let's go
        <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">viral</span>
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">Join
        thousands of brands scaling
        creator-powered content</p>

    <!-- Honeypot — hidden from real users, catches bots -->
    <input #honeypotInput type="text" name="middleName" autocomplete="off" tabindex="-1" aria-hidden="true"
        style="position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;opacity:0" />



    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">
        <div class="grid grid-cols-1 gap-x-6 gap-y-5 sm:gap-y-6 sm:grid-cols-6">



            <div class="sm:col-span-6">
                <label for="firstNameInput" class="block text-sm/6 font-medium text-primary">First name</label>
                <div class="mt-2 grid grid-cols-1">
                    <input #firstNameInput [formField]="slickOnboardService.userProfileForm.firstName" id="firstNameInput"
                        type="text" placeholder="Jane"
                        class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                </div>
                @if (slickOnboardService.userProfileForm.firstName().touched() &&
                slickOnboardService.userProfileForm.firstName().invalid()) {
                <ul class="error-list">
                    @for (error of slickOnboardService.userProfileForm.firstName().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
            </div>

            <div class="sm:col-span-6">
                <label for="lastNameInput" class="block text-sm/6 font-medium text-primary">Last name</label>
                <div class="mt-2 grid grid-cols-1">
                    <input #lastNameInput [formField]="slickOnboardService.userProfileForm.lastName" id="lastNameInput"
                        type="text" placeholder="Smith"
                        class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                </div>
                @if (slickOnboardService.userProfileForm.lastName().touched() &&
                slickOnboardService.userProfileForm.lastName().invalid()) {
                <ul class="error-list">
                    @for (error of slickOnboardService.userProfileForm.lastName().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
            </div>

            <!-- Email + Send code -->
            <div class="sm:col-span-6">
                <label for="emailInput" class="block text-sm/6 font-medium text-primary">Work Email Address</label>
                <div class="mt-2 flex flex-col gap-2 sm:flex-row sm:items-stretch sm:gap-3">
                    <div class="min-w-0 flex-1 grid grid-cols-1">
                        <input #emailInput [formField]="slickOnboardService.userProfileForm.email" id="emailInput"
                            type="email" placeholder="you@yourcompany.com" autocomplete="email"
                            class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11"
                            [class.opacity-60]="otpVerified()" [class.pointer-events-none]="otpVerified()"
                            (keyup.enter)="sendCode()" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4"
                            aria-hidden="true">
                            <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                            <rect x="2" y="4" width="20" height="16" rx="2" />
                        </svg>
                    </div>
                    @if (!otpVerified()) {
                    <button type="button" (click)="sendCode()" [disabled]="!canSendCode()"
                        aria-label="Send or resend email verification code"
                        class="primary-go-button w-full sm:w-auto shrink-0 justify-center gap-x-2 px-4 disabled:opacity-40 touch-manipulation focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                        @if (isSendingOtp()) {
                        <svg class="animate-spin size-4 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" aria-hidden="true">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                        </svg>
                        <span class="sr-only">Sending code</span>
                        } @else if (otpSent() && resendCooldown() > 0) {
                        Resend in {{ resendCooldown() }}s
                        } @else if (otpSent()) {
                        Resend code
                        } @else {
                        Send code
                        }
                    </button>
                    } @else {
                    <div
                        class="badge-success inline-flex items-center justify-center gap-1.5 shrink-0 self-center sm:self-stretch sm:px-4 text-sm font-semibold">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            aria-hidden="true">
                            <path d="M20 6 9 17l-5-5" />
                        </svg>
                        Verified
                    </div>
                    }
                </div>

                <!-- Email validation errors -->
                @if (slickOnboardService.userProfileForm.email().touched() &&
                slickOnboardService.userProfileForm.email().invalid()) {
                <ul class="error-list">
                    @for (error of slickOnboardService.userProfileForm.email().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
                @if (!slickOnboardService.userProfileForm.email().invalid() && isBlockedDomain()) {
                <ul class="error-list">
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        Please use your work or business email address
                    </li>
                </ul>
                }

                <!-- OTP input — shown after code is sent and before verified -->
                @if (otpSent() && !otpVerified()) {
                <div class="mt-2 sm:col-span-6">
                    <p class="text-sm text-secondary mb-2">
                        We sent a 6-digit code to
                        <span class="font-medium text-primary">{{ slickOnboardService.userProfileModel().email
                            }}</span>.
                        Enter it below:
                    </p>
                    <input type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6"
                        placeholder="000000" [value]="otpValue()" (input)="onOtpInput($event)"
                        [disabled]="isVerifyingOtp()"
                        class="block w-full max-w-[200px] rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-4 py-2 text-center text-2xl font-mono tracking-[0.5em] text-primary focus:outline-none focus:ring-2 focus:ring-primary disabled:opacity-50" />
                    @if (otpError()) {
                    <ul class="error-list mt-1">
                        <li class="text-error-light flex items-start gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                <path d="M12 9v4" />
                                <path d="M12 17h.01" />
                            </svg>
                            {{ otpError() }}
                        </li>
                    </ul>
                    }
                    @if (isVerifyingOtp()) {
                    <p class="text-sm text-secondary mt-1">Verifying…</p>
                    }
                </div>
                }

                <!-- OTP send error (before OTP input shown) -->
                @if (!otpSent() && otpError()) {
                <div class="sm:col-span-6">
                    <ul class="error-list">
                        <li class="text-error-light flex items-start gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                <path d="M12 9v4" />
                                <path d="M12 17h.01" />
                            </svg>
                            {{ otpError() }}
                        </li>
                    </ul>
                </div>
                }

                <!-- Turnstile widget (invisible) -->
                <!-- <div #turnstileContainer class="absolute bottom-0 end-0 left-0 w-full flex flex-row items-end justify-end" -->
                <div #turnstileContainer class="w-full flex flex-row mt-2 " aria-hidden="true"></div>
            </div>

            @if (otpVerified()) {
            <div class="sm:col-span-6">
                <label for="passwordInput" class="block text-sm/6 font-medium text-primary">Password</label>
                <div class="mt-2 grid grid-cols-1 relative">
                    <input #passwordInput [formField]="slickOnboardService.userProfileForm.password" id="passwordInput"
                        (keyup.enter)="saveProfileInfo()" [type]="passwordVisible ? 'text' : 'password'"
                        placeholder="Password"
                        class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4">
                        <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                    </svg>
                    <button type="button" (click)="passwordVisible = !passwordVisible"
                        class="absolute right-2 inset-y-0 flex items-center p-2 -m-2 text-gray-500 dark:text-gray-400 hover:text-gray-400 dark:hover:text-gray-300 focus:outline-none touch-manipulation"
                        aria-label="{{ passwordVisible ? 'Hide password' : 'Show password' }}">
                        @if (passwordVisible) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="m15 18-.722-3.25" />
                            <path d="M2 8a10.645 10.645 0 0 0 20 0" />
                            <path d="m20 15-1.726-2.05" />
                            <path d="m4 15 1.726-2.05" />
                            <path d="m9 18 .722-3.25" />
                        </svg>
                        } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                        }
                    </button>
                </div>

                <!-- Password strength meter -->
                @if (slickOnboardService.userProfileForm.password().dirty()) {
                <div class="mt-2 flex flex-col gap-1.5">
                    <div class="flex flex-row gap-0.5" role="meter" aria-label="Password strength"
                        [attr.aria-valuenow]="passwordStrength().level" aria-valuemin="0" aria-valuemax="4">
                        @for (segment of [1,2,3,4]; track segment) {
                        <div class="h-1.5 flex-1 rounded-full transition-colors"
                            [class.bg-gray-300]="segment > passwordStrength().level"
                            [class.dark:bg-gray-600]="segment > passwordStrength().level"
                            [class.bg-red-500]="segment <= passwordStrength().level && passwordStrength().label === 'Weak'"
                            [class.bg-amber-500]="segment <= passwordStrength().level && passwordStrength().label === 'Fair'"
                            [class.bg-yellow-500]="segment <= passwordStrength().level && passwordStrength().label === 'Medium'"
                            [class.bg-green-500]="segment <= passwordStrength().level && passwordStrength().label === 'Strong'">
                        </div>
                        }
                    </div>
                    @if (slickOnboardService.userProfileModel().password &&
                    slickOnboardService.userProfileModel().password.length > 0) {
                    <span class="text-xs font-medium transition-colors"
                        [class.text-red-500]="passwordStrength().label === 'Weak'"
                        [class.text-amber-500]="passwordStrength().label === 'Fair'"
                        [class.text-yellow-500]="passwordStrength().label === 'Medium'"
                        [class.text-green-500]="passwordStrength().label === 'Strong'">{{ passwordStrength().label
                        }}</span>
                    }
                </div>
                }

                @if (slickOnboardService.userProfileForm.password().touched() &&
                slickOnboardService.userProfileForm.password().invalid()) {
                <ul class="error-list">
                    @for (error of slickOnboardService.userProfileForm.password().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
            </div>
            }

            <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:col-span-full">
                <p class="text-center sm:text-left text-sm/6 text-secondary order-2 sm:order-1">
                    Already have an account?
                    <a routerLink="/login"
                        class="font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85 cursor-pointer inline-block py-2 touch-manipulation">Sign
                        in</a>
                </p>

                @if (otpVerified()) {
                <button type="button" id="continue-button" (click)="saveProfileInfo()" [disabled]="!canSubmit()"
                    class="w-full sm:w-auto sm:min-w-40 text-center primary-go-button flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold touch-manipulation order-1 sm:order-2 disabled:opacity-40 disabled:cursor-not-allowed">

                    <p class="block">Continue</p>

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 shrink-0">
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>

                </button>
                }
            </div>

            <div class="w-full col-span-full mt-8 sm:mt-10">
                <div class="mx-auto max-w-7xl px-0 sm:px-6 lg:px-8">
                    <h2 class="text-center text-xs sm:text-sm text-secondary">Trusted by the world's most innovative
                        teams</h2>
                    <div
                        class="mx-auto mt-4 grid max-w-lg grid-cols-2 items-center gap-x-4 gap-y-6 sm:grid-cols-4 sm:gap-x-8 sm:gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-5 lg:gap-x-10">
                        <img width="158" height="auto" src="../../../../../assets/logos/cloud/adobe_dark.svg"
                            alt="Transistor"
                            class="max-h-10 sm:max-h-12 w-full object-contain invert dark:invert-0 opacity-80 dark:opacity-100 lg:col-span-1" />

                        <img width="158" height="auto" src="../../../../../assets/logos/cloud/byd_dark.svg"
                            alt="Transistor"
                            class="max-h-10 sm:max-h-12 w-full object-contain invert dark:invert-0 opacity-80 dark:opacity-100 lg:col-span-1" />

                        <img width="158" height="auto" src="../../../../../assets/logos/cloud/golin_dark.svg"
                            alt="Transistor"
                            class="max-h-10 sm:max-h-12 w-full object-contain invert dark:invert-0 opacity-80 dark:opacity-100 lg:col-span-1" />

                        <img width="158" height="auto" src="../../../../../assets/logos/cloud/pizzahut_dark.svg"
                            alt="Transistor"
                            class="max-h-10 sm:max-h-12 w-full object-contain invert dark:invert-0 opacity-80 dark:opacity-100 lg:col-span-1" />

                        <img width="158" height="auto" src="../../../../../assets/logos/cloud/monday_light.svg"
                            alt="Transistor"
                            class="dark:hidden max-h-10 sm:max-h-12 w-full object-contain lg:col-span-1" />
                        <img width="158" height="auto" src="../../../../../assets/logos/cloud/monday_dark.svg"
                            alt="Transistor"
                            class="hidden dark:block max-h-10 sm:max-h-12 w-full object-contain lg:col-span-1" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>